import { getPantoneNameByFormColor } from '../../../../../../../helpers/entities/pantone/get-pantone-name-by-form-color'
import { PrintJobPaintsRow } from '../../../../../../../types/api/print-job-paints'

/** Название пантона карточки: из черновика, иначе по цвету формы. */
export function getRowPantoneName({ form, draft }: PrintJobPaintsRow) {
    return draft?.pantoneName ?? getPantoneNameByFormColor(form.colorName)
}
